
import * as React from 'react';

import { IPanelProps, Panel } from 'core/decorators/Panel';
import PageLinkConfig from "./PageLinkConfig";
import PageLinkView from "../../common/views/pageLink/PageLink.view";
import { ButtonView } from "../../common/views/button/Button.view";


@Panel({id: "pageLink", configClass: PageLinkConfig})
export class PageLinkPanel extends React.PureComponent<IPanelProps<PageLinkConfig>> {

	public render() {
		const { linkText } = this.props.config;

		return (
			<PageLinkView viewKey="link" >
				<ButtonView viewKey="button">
					{linkText}
				</ButtonView>
			</PageLinkView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/pageLink/PageLink.panel.tsx